// 合作流程
import React from 'react'
import styles from './CooperationProcess.module.scss'
import step1 from '@assets/img/step1.png'
import step2 from '@assets/img/step2.png'
import step3 from '@assets/img/step3.png'
import step4 from '@assets/img/step4.png'
import arrow from '@assets/img/arrow.png'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { createAgentI18n } from '@/utils/i18n'

const CooperationProcess: React.FC<WithI18nProps> = (props) => {
  const { i18n } = props
  const t = React.useMemo(() => createAgentI18n(i18n), [i18n])
  const steps = [
    {
      id: '01',
      title: t('cooperationProcess1', "提交合作意向"),
      desc: t('cooperationProcess1Description', "提交联系人信息并提交初步合作意向"),
      img: step1
    },
    {
      id: '02',
      title: t('cooperationProcess2', "平台确认合作意向"),
      desc: t('cooperationProcess2Description', "平台联系初审资质，敲定合作意向"),
      img: step2
    },
    {
      id: '03',
      title: t('cooperationProcess3', "资质审核"),
      desc: t('cooperationProcess3Description', "正式提交企业资质，平台完成审核"),
      img: step3
    },
    {
      id: '04',
      title: t('cooperationProcess4', "签署协议，缴纳保证金"),
      desc: t('cooperationProcess4Description', "正式签约，缴纳保证金，开展合作"),
      img: step4
    }
  ]

  return (
    <section className={styles.section}>
      <div className={styles.title}>{t('cooperationProcess', "合作流程")}</div>
      <div className={styles.processContainer}>
        {steps.map((step, index) => (
          <div key={step.id} className={styles.stepWrapper}>
            <div className={styles.stepContent}>
              <div className={styles.stepImg}>
                <img src={step.img} alt={step.title} />
              </div>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepDesc}>{step.desc}</p>
            </div>
            {index < steps.length - 1 && (
              <div className={styles.arrowImg}>
                <img src={arrow} alt="arrow" />
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}

const CooperationProcessWithTranslator = withTranslator(CooperationProcess)
export default CooperationProcessWithTranslator
